<template>
  <MainLayout>
    <Head>
      <title>{{ title }}</title>
    </Head>
    <template v-slot:header>
      {{ title }}
    </template>

    <FormWrapper grid>
      <form @submit.prevent="submit">
        <FormInput name="name"
                   v-model="form.name"
                   :errors="errors"
                   @change="uppercaseName"
                   class="sm:col-span-4"/>

        <FormInput name="label"
                   v-model="form.label"
                   :errors="errors"
                   class="sm:col-span-4"/>

        <FormCheckbox v-model="form.has_image"
                      name="has_image"
                      class="col-span-4"
                      description="Check this option to allow setting images for values"
                      :errors="errors" />

        <FormInput name="image"
                   v-model="form.image"
                   :errors="errors"
                   class="sm:col-span-4"/>

        <FormTextarea name="description"
                      v-model="form.description"
                      :errors="errors"
                      class="sm:col-span-4"/>

        <div class="sm:col-span-2"></div>

        <FormSelect name="type"
                    v-model="form.type"
                    :errors="errors"
                    :options="optionTypes"
                    class="sm:col-span-2" />

        <FormSelect name="paired_with"
                    v-model="form.paired_with"
                    :errors="errors"
                    :options="pairedWithOptions"
                    class="sm:col-span-2" />

        <FormInput v-if="exists"
                   name="sort_order"
                   label="Order in Spreadsheet"
                   v-model="form.sort_order"
                   :errors="errors"
                   type="number"
                   min="0"
                   step="1"
                   :max="maxSortOrder"
                   class="sm:col-span-4">
          <template v-slot:description>
            The values start from 0
          </template>
        </FormInput>

        <FormActions :cancelUrl="$route('options.index')"
                     :show-submit="$can('options.write')"
                     grid />
      </form>
    </FormWrapper>
  </MainLayout>
</template>

<script>
import PageComponent from '@/pages/page-component'
import FormComponent from '@/pages/form-component'
import { Inertia } from '@inertiajs/inertia'
import UsesPermissions from '@/mixins/uses-permissions'

export default {
  mixins: [
    PageComponent,
    FormComponent,
    UsesPermissions,
  ],

  props: {
    model: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    errors: Object,
    optionTypes: Array,
    maxSortOrder: Number,
    pairedWithOptions: Array,
  },

  data() {
    return {
      title: `Options :: ${this.model?.name}`,
      exists: !!this.model?.id,
      form: {
        name: this.model?.name?.toUpperCase(),
        label: this.model?.label,
        image: this.model?.image,
        type: this.model?.type,
        has_image: this.model?.has_image,
        description: this.model?.description,
        sort_order: this.model?.sort_order,
        paired_with: this.model?.paired_with,
      },
    }
  },

  methods: {
    uppercaseName() {
      this.form.name = this.form.name.toUpperCase()
    },

    submit() {
      Inertia.put(this.$route('options.update', [this.model.id]), this.form)
    }
  }
}
</script>
